import { render, staticRenderFns } from "./QuotaProgressBar.vue?vue&type=template&id=bf75c3d4&"
import script from "./QuotaProgressBar.vue?vue&type=script&lang=js&"
export * from "./QuotaProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports